import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicServerPowerStartParamsRawI,
	LWApiPublicServerPowerStartResultRawI,
} from '@liquidweb-dev/club-sauce/public/server/power.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { NOTIFICATIONS_CURRENT_QUERY_KEY } from 'modules/queries/notification/useCurrent';
import useInvalidateAssets from 'modules/queries/invalidateQueries/useInvalidateAssets';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useServerPowerStart = () => {
	const snackbarError = useSnackbarError();
	const invalidateAssets = useInvalidateAssets();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicServerPowerStartResultRawI,
		ApiErrorI,
		LWApiPublicServerPowerStartParamsRawI
	>({
		mutationFn: (params) => api.server.power.apiRaw.start(params),
		onSuccess: (_data, params) => {
			invalidateAssets(params.uniq_id);

			queryClient.invalidateQueries({
				queryKey: [NOTIFICATIONS_CURRENT_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useServerPowerStart;
